import _ from 'lodash';
import $ from 'jquery';
import widgetFactory from '../widgetFactory';
import TemplateNotFoundException from './Exceptions/TemplateNotFoundException';
import keyCodes from 'Modules/key-codes';

const WIDGET_NAME = 'immersiveVideo';
const PLAYER_TEMPLATE_SELECTOR = '.js-immersive-video-player-template';
const FADE_DURATION = 800;
const PLAYER_Z_INDEX = 1100;

export default widgetFactory(WIDGET_NAME, {
  _create: function () {
    this._super(WIDGET_NAME);
    this.isVideoPlaying = false;

    if (_.isEmpty($(PLAYER_TEMPLATE_SELECTOR))) {
      throw new TemplateNotFoundException({
        templateSelector: PLAYER_TEMPLATE_SELECTOR,
      });
    }

    this.url = this.element.attr('data-immersive-video-url');
    this.label = this.element.attr('title');
    this.subtitle = this.element.attr('data-immersive-video-subtitle');

    this.$player = $(
      _.template($(PLAYER_TEMPLATE_SELECTOR).html())({
        videoUrl: this.url,
        videoLabel: this.label,
        videoSubtitle: this.subtitle ? JSON.parse(this.subtitle) || [] : [],
      })
    );

    this.$video = this.$player.find('.js-video');
    this.videoElement = this.$video.get(0);
    this.$closeButton = this.$player.find('.js-close');

    window.addEventListener('resize', this._onResize.bind(this));
    this.element.on('click', this._onStartVideoClick.bind(this));
    this.$player.on('click', this._onPlayerClick.bind(this));
    this.$closeButton.on('click', this._onCloseButtonClick.bind(this));
    $(document).on('keyup', this._onKeyUp.bind(this));

    $('body').append(this.$player);
    this.$player.css('z-index', -PLAYER_Z_INDEX);
  },

  _onStartVideoClick: function () {
    if (this.videoElement.readyState === 0) {
      this.videoElement.addEventListener('loadeddata', () => {
        this._openVideoPlayer();
      });
      this.videoElement.load();
    } else {
      this._openVideoPlayer();
    }
  },

  _openVideoPlayer: function () {
    $('body').addClass('blockScroll');
    this.$player.css('z-index', PLAYER_Z_INDEX);
    this.$player.removeClass('hide');
    this.$video.height(window.innerHeight);
    this._playVideo();
  },

  _onPlayerClick: function () {
    if (this.$player.hasClass('hide')) {
      setTimeout(() => {
        this.$player.removeClass('video-play');
      }, FADE_DURATION);
      return;
    }

    if (this.isVideoPlaying) {
      this._pauseVideo();
      this.$player.addClass('video-play');
    } else {
      this._playVideo();
      this.$player.removeClass('video-play');
    }
  },

  _onCloseButtonClick: function () {
    this._hideVideo();
  },

  _onKeyUp: function (event) {
    if (event.keyCode === keyCodes.ESCAPE) {
      this._hideVideo();
    }
  },

  _onResize: function (event) {
    this.$video.height(event.target.innerHeight);
  },

  _hideVideo: function () {
    if (!this.$player.hasClass('hide')) {
      $('body').removeClass('blockScroll');
      this.$player.addClass('hide');
      this._pauseVideo();
      setTimeout(() => {
        this.$player.removeClass('video-play');
        this.$player.css('z-index', -PLAYER_Z_INDEX);
      }, FADE_DURATION);
    }
  },

  _playVideo: function () {
    if (!_.isNil(this.videoElement.play)) {
      this.videoElement.play();
    }
    this.isVideoPlaying = true;
  },

  _pauseVideo: function () {
    if (!_.isNil(this.videoElement.pause)) {
      this.videoElement.pause();
    }
    this.isVideoPlaying = false;
  },
});
